module.exports = __webpack_public_path__ + "img/amazon_s3.0fd7ad6f.png";